import React from 'react'

function Play ({ className, fill }) {
  return (
    <svg fill={fill} className={className} width='16' height='20.62' viewBox='0 0 16 20.62'>
      <path d='M10.31,0,20.62,16H0Z' transform='translate(16) rotate(90)' />
    </svg>
  )
}

Play.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Play
